import PropTypes from 'prop-types';
import { Box } from '@mui/material';

const IconFileWord = (props) => {
  const { fontSize = '1.5rem', color = 'text.disabled', filled = true, ...other } = props;

  if (!filled) {
    console.debug('IconFileWord needs to be created also as outlined icon');
  }

  return (
    <Box component="span" display="block" height={fontSize} width={fontSize} {...other}>
      <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12 2C11.8879 2.00068 11.7761 2.01268 11.6663 2.03581L11.6647 2.03418L3.38346 3.69108L3.35742 3.69596L3.35579 3.69759C2.9748 3.76993 2.63095 3.97285 2.38348 4.27143C2.136 4.57 2.00039 4.94553 2 5.33333V18.6667C2.00008 19.055 2.13575 19.4311 2.38358 19.73C2.63142 20.029 2.97585 20.232 3.35742 20.304L11.6582 21.9642L11.6647 21.9658C11.775 21.9885 11.8874 22 12 22C12.442 22 12.866 21.8244 13.1785 21.5118C13.4911 21.1993 13.6667 20.7754 13.6667 20.3333V3.66667C13.6667 3.22464 13.4911 2.80072 13.1785 2.48816C12.866 2.17559 12.442 2 12 2ZM15.3333 3.66667V6.16667H18.6667C19.1267 6.16667 19.5 6.54 19.5 7C19.5 7.46 19.1267 7.83333 18.6667 7.83333H15.3333V9.5H18.6667C19.1267 9.5 19.5 9.87333 19.5 10.3333C19.5 10.7933 19.1267 11.1667 18.6667 11.1667H15.3333V12.8333H18.6667C19.1267 12.8333 19.5 13.2067 19.5 13.6667C19.5 14.1267 19.1267 14.5 18.6667 14.5H15.3333V16.1667H18.6667C19.1267 16.1667 19.5 16.54 19.5 17C19.5 17.46 19.1267 17.8333 18.6667 17.8333H15.3333V20.3333H20.3333C21.2542 20.3333 22 19.5875 22 18.6667V5.33333C22 4.4125 21.2542 3.66667 20.3333 3.66667H15.3333ZM3.88639 7.83333H5.43587L6.21875 13.3607H6.29199L7.23112 7.83333H8.42741L9.40072 13.3607H9.47396L10.2422 7.83333H11.7803L10.2471 16.1667H8.84733L7.86588 11.0609H7.79264L6.8291 16.1667H5.4196L3.88639 7.83333Z"
          fill={color}
        />
      </svg>
    </Box>
  );
};

IconFileWord.propTypes = {
  color: PropTypes.string,
  filled: PropTypes.bool,
  fontSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

export default IconFileWord;
